export const EXPLAINER_STEP = 'explainer';
export const INTRO_STEP = 'intro';
export const APPLICATION_STEP = 'application';
export const OFFER_LOADER_STEP = 'offer-loader';
export const OFFER_STEP = 'offer';
export const SOFT_REJECTION = 'soft-rejection';
export const ACTIVATED_STEP = 'activated';
export const ACTIVATED_NON_PINWHEEL_STEP = 'activated-non-pinwheel';
export const OPT_OUT_STEP = 'opt-out';
export const REVIEW_DIRECT_DEPOSIT_STEP = 'review-direct-deposit';
export const PINWHEEL_STEP = 'pinwheel';
export const MANUAL_PAYMENT_SETUP_STEP = 'manual-payment-setup';
export const PINWHEEL_ERROR_STEP = 'pinwheel-error';
export const INSTRUCTIONS_STEP = 'instructions';
export const PAYROLL_PAYMENT_SETUP_STEP = 'payroll-payment-setup';

export const PERPAY_PLUS_SOLO_APPLICATION_STEPS = [
    EXPLAINER_STEP,
    INTRO_STEP,
    APPLICATION_STEP,
    OFFER_LOADER_STEP,
    OFFER_STEP,
    SOFT_REJECTION,
    ACTIVATED_STEP,
    ACTIVATED_NON_PINWHEEL_STEP,
    OPT_OUT_STEP,
    REVIEW_DIRECT_DEPOSIT_STEP,
    PINWHEEL_STEP,
    MANUAL_PAYMENT_SETUP_STEP,
    PINWHEEL_ERROR_STEP,
    INSTRUCTIONS_STEP,
    PAYROLL_PAYMENT_SETUP_STEP,
];

export const PERPAY_PLUS_SOLO_SIGN_UP_STEPS = [
    INTRO_STEP,
    APPLICATION_STEP,
    OFFER_STEP,
];
